export default __webpack_public_path__ + "static/media/SWT0520.34I-20393_-14787_0.5c33c726.jpg";